//export const API_URL = 'http://192.168.1.14:5555/api';
export const API_URL = 'https://stranslate.ebslab.in/api';
